// extracted by mini-css-extract-plugin
module.exports = {"container":"paperBar_container__10o1o","paper":"paperBar_paper__3arS6"};